import React, { useEffect, useState } from "react";
import { themes, optionalAvathar } from "services/constants";
import { useForm } from "react-hook-form";
import * as Icons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { CustomButton } from "components/CustomComponents/CustomButton";
import sessionHandling from "services/utils/notificationUtils";
import { customAPI } from "services/utils/CustomAPI";
import PropTypes from "prop-types";
import Switch from "@mui/material/Switch";
import { Close } from "@mui/icons-material";
import { useFetch } from "services/hooks/useFetch";
import { formKeyText, tooltipStyleProps } from "services/constants/Styles";

export const EditDepartment = ({
  setOpenEditScreen,
  editDepartmentDetails,
  setDepartmentApi,
}) => {
  const { domain, token, userDetails } = useSelector(
    (state) => state.tokenReducer
  );
  const [departmentLeadName, setDepartmentLeadName] = useState(
    editDepartmentDetails.department_lead_name
  );
  const [departmentProxyName, setDepartmentProxyName] = useState(
    editDepartmentDetails.proxy_name
  );
  const [departmentName, setDepartmentName] = useState(
    editDepartmentDetails.department_name
  );
  const [workUnit, setWorkUnit] = useState(editDepartmentDetails?.work_unit);
  const { result: departmentLeadList } = useFetch(`${domain}all-members/`);
  const [editValue, setEditValue] = useState(true);
  const [buttonLoader, setButtonLoader] = useState(false);

  const {
    setValue,
    handleSubmit,
    reset,
    register,
    watch,
    formState: { errors },
  } = useForm({ mode: "onBlur" });

  useEffect(() => {
    if (editValue) {
      setValue("department", editDepartmentDetails.department_name);
      setValue("departmentLead", editDepartmentDetails.department_lead_name);
      setValue("proxyName", editDepartmentDetails.proxy_name);
      setValue("departmentLeadId", editDepartmentDetails.department_lead_id);
      setValue("departmentProxy", editDepartmentDetails.proxy_id);
      setEditValue(false);
    }
  }, [
    editDepartmentDetails.department_lead_id,
    editDepartmentDetails.department_lead_name,
    editDepartmentDetails.department_name,
    editDepartmentDetails.proxy_id,
    editDepartmentDetails.proxy_name,
    editDepartmentDetails.shift_categories,
    editDepartmentDetails.shift_category_id,
    editDepartmentDetails.shift_category_name,
    editValue,
    setValue,
  ]);

  const onSubmit = async (data) => {
    setButtonLoader(true);
    if (data) {
      const response = await customAPI(`${domain}edit_department/`, "PUT", {
        department_lead_id: data.departmentLeadId,
        departmentname: data.department.trim(),
        department_id: editDepartmentDetails.department_id,
        proxy_id: data.departmentProxy,
        approved_by: userDetails.username,
        work_unit: workUnit,
      });
      if (response.ok) {
        reset();
        setOpenEditScreen(false);
        setDepartmentApi(true);
        showToast("success", response?.responseDetails?.message);
      } else {
        setButtonLoader(false);
      }
    }
  };

  const checkSpecialChar = (e) => {
    if (!/^[a-zA-Z0-9 ]*$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const hadleWorkUnit = (event) => {
    setWorkUnit(event.target.checked);
    // setSelectedShift([]);
  };

  return (
    <React.Fragment>
      <Mui.Grid container sx={{ paddingTop: 1 }}>
        <BackArrow actionFunction={() => setOpenEditScreen(false)} />
        <Mui.Typography
          sx={{ fontWeight: "bold", fontSize: 25, paddingTop: 1 }}
        >
          Departments / Edit Department
        </Mui.Typography>
      </Mui.Grid>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Mui.Grid container sx={{ paddingTop: 2 }}>
          <Mui.Grid xs={12} sm={12} md={3} lg={2.5}></Mui.Grid>
          <Mui.Grid xs={12} sm={12} md={6} lg={7.5} sx={{ paddingTop: 10 }}>
            <Mui.Grid container component={Mui.Paper}>
              <Mui.Grid
                xs={12}
                sx={{
                  padding: 1,
                  backgroundColor: themes.primary,
                  borderRadius: "10px 10px 0 0",
                  border: `2px solid ${themes.sidebarDivider}`,
                  borderBottom: "none",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Mui.Typography
                  sx={{ fontSize: 24, fontWeight: 800, font: "bold" }}
                >
                  Edit Department
                </Mui.Typography>
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Stack
              sx={{
                paddingTop: 1,
                padding: 5,
                borderRadius: "0 0 10px 10px",
                border: `2px solid ${themes.sidebarDivider}`,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Mui.Grid container sx={{ paddingTop: 1 }}>
                <Mui.Grid xs={4}>
                  <Mui.Typography sx={formKeyText}>
                    Department name&nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title={
                        "Modify the department name if needed. Ensure it remains clear and distinct to avoid confusion across teams."
                      }
                    >
                      <Icons.Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid xs={8}>
                  <Mui.TextField
                    size="small"
                    placeholder="Enter department name"
                    sx={{
                      borderWidth: "10px solid black",
                      paddingBottom: 2,
                    }}
                    {...register("department", {
                      required: "Department is required",
                      maxLength: {
                        value: 30,
                        message: "Maximum length is 30 characters",
                      },
                      validate: {
                        noDigitsOrSpecial: (fieldValue) => {
                          if (!/[A-Za-z]/.test(fieldValue)) {
                            return "Department Name must contain at least one alphabet character.";
                          }
                          if (/^\d+$/.test(fieldValue)) {
                            return "Department Name should not contain only digits.";
                          }
                          if (!/^[A-Za-z0-9\s&-]+$/.test(fieldValue)) {
                            return "Department name should only contain alphabets, spaces, -,numbers and & symbol.";
                          }
                          return true;
                        },
                        checkUnique: async (fieldValue) => {
                          if (
                            fieldValue !== "" &&
                            fieldValue !==
                              editDepartmentDetails.department_name &&
                            !buttonLoader
                          ) {
                            setButtonLoader(true);
                            try {
                              const response = await fetch(
                                `${domain}check_department_name/?department_name=${fieldValue.trim()}`,
                                {
                                  method: "GET",
                                  headers: {
                                    "content-type": "application/json",
                                    Authorization: `token ${token}`,
                                  },
                                }
                              );
                              const res = await response.json();
                              if (response.ok) {
                                if (res.exists) {
                                  return "The department name has been already taken.Use a unique department name to proceed further";
                                } else {
                                  return true;
                                }
                              } else if (response.status === 409) {
                                sessionHandling();
                              } else {
                                throw new Error(res.error);
                              }
                            } catch (error) {
                              showToast("error", error.message);
                            } finally {
                              setButtonLoader(false);
                            }
                          }
                        },
                      },
                    })}
                    onChange={(event) => {
                      setDepartmentName(event.target.value);
                      setValue("department", event.target.value);
                    }}
                    value={departmentName}
                    error={Boolean(errors.department)}
                    helperText={errors.department?.message || ""}
                    onKeyPress={checkSpecialChar}
                    InputProps={{
                      startAdornment: (
                        <Mui.InputAdornment>
                          <Mui.InputAdornment>
                            <Icons.AddBusiness
                              style={{
                                color: "#a6a6a6",
                              }}
                            />
                            &nbsp;
                          </Mui.InputAdornment>
                        </Mui.InputAdornment>
                      ),
                    }}
                    fullWidth
                    disabled={
                      editDepartmentDetails?.department_name === "General"
                        ? true
                        : false
                    }
                  />
                </Mui.Grid>
              </Mui.Grid>
              <Mui.Grid container sx={{ paddingTop: 1 }}>
                <Mui.Grid xs={4}>
                  <Mui.Typography sx={formKeyText}>
                    Is workunit applicable ?&nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title={
                        "Toggle this option to update whether the department uses work units for performance or task tracking."
                      }
                    >
                      <Icons.Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid xs={8}>
                  <Switch
                    checked={workUnit}
                    onChange={hadleWorkUnit}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Mui.Grid>
              </Mui.Grid>
              <Mui.Grid container sx={{ paddingTop: 1 }}>
                <Mui.Grid xs={4}>
                  <Mui.Typography sx={formKeyText}>
                    Department Lead&nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title={
                        "Update the primary person responsible for managing the department.Useful in case of role changes or leadership shifts."
                      }
                    >
                      <Icons.Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid xs={8}>
                  <Mui.Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    size="small"
                    value={departmentLeadName}
                    options={departmentLeadList.map((obj) => ({
                      ...obj,
                      label: obj.username,
                    }))}
                    sx={{ width: "100%" }}
                    ListboxProps={{ style: { maxHeight: "150px" } }}
                    filterOptions={(options, state) => {
                      return options.filter((option) =>
                        option.label
                          .toLowerCase()
                          .includes(state.inputValue.toLowerCase())
                      );
                    }}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <img
                          src={option.image_url ?? optionalAvathar}
                          alt={option.label}
                          style={{
                            width: 25,
                            height: 25,
                            marginRight: 5,
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                        {option.label}
                      </li>
                    )}
                    onChange={(event, value) => {
                      if (value) {
                        setDepartmentLeadName(value.username);
                        setValue("departmentLeadId", value.id);
                      } else {
                        setValue("departmentLeadId", null);
                        setDepartmentLeadName("");
                      }
                    }}
                    renderInput={(params) => (
                      <Mui.TextField
                        {...params}
                        value={departmentLeadName}
                        {...register("departmentLead", {
                          required: "Department lead is required",
                        })}
                        sx={{
                          background: themes.whiteColor,
                          maxHeight: 120,
                          paddingBottom: 2,
                        }}
                        placeholder="Select department lead"
                        size="small"
                        error={Boolean(errors.departmentLead)}
                        helperText={errors.departmentLead?.message || ""}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              {departmentLeadName && (
                                <img
                                  src={
                                    departmentLeadList.find(
                                      (u) => u?.id === watch("departmentLeadId")
                                    )?.image_url ?? optionalAvathar
                                  }
                                  alt="avatar"
                                  style={{
                                    width: 25,
                                    height: 25,
                                    borderRadius: "50%",
                                    marginRight: 1,
                                    objectFit: "cover",
                                  }}
                                />
                              )}
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                        fullWidth
                      />
                    )}
                  />
                </Mui.Grid>
              </Mui.Grid>
              <Mui.Grid container>
                <Mui.Grid xs={4}>
                  <Mui.Typography sx={formKeyText}>
                    Proxy&nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title={
                        "Change the proxy (alternate lead) who can take action in the absence of the primary lead.This helps maintain continuity in approvals and operations."
                      }
                    >
                      <Icons.Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid xs={8}>
                  <Mui.Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    size="small"
                    value={departmentProxyName}
                    options={departmentLeadList.map((obj) => ({
                      ...obj,
                      label: obj.username,
                    }))}
                    sx={{ width: "100%", paddingBottom: 2 }}
                    ListboxProps={{ style: { maxHeight: "150px" } }}
                    filterOptions={(options, state) => {
                      return options.filter((option) =>
                        option.label
                          .toLowerCase()
                          .includes(state.inputValue.toLowerCase())
                      );
                    }}
                    renderOption={(props, option) => {
                      if (departmentLeadName === option.username) return null;
                      return (
                        <li
                          {...props}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <img
                            src={option.image_url ?? optionalAvathar}
                            alt={option.username}
                            style={{
                              width: 28,
                              height: 28,
                              borderRadius: "50%",
                              marginRight: 5,
                              objectFit: "cover",
                            }}
                          />
                          {option.username}
                        </li>
                      );
                    }}
                    onChange={(event, value) => {
                      if (value) {
                        setDepartmentProxyName(value.username);
                        setValue("departmentProxy", value.id);
                      } else {
                        setValue("departmentProxy", null);
                        setDepartmentProxyName("");
                      }
                    }}
                    renderInput={(params) => (
                      <Mui.TextField
                        {...params}
                        value={departmentProxyName}
                        {...register("proxyName", {
                          required: "Proxy name is required",
                        })}
                        sx={{
                          background: themes.whiteColor,
                          maxHeight: 120,
                        }}
                        placeholder="Select proxy name"
                        size="small"
                        error={Boolean(errors.proxyName)}
                        helperText={errors.proxyName?.message || ""}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              {departmentProxyName && (
                                <img
                                  src={
                                    departmentLeadList.find(
                                      (u) => u?.id === watch("departmentProxy")
                                    )?.image_url ?? optionalAvathar
                                  }
                                  alt="avatar"
                                  style={{
                                    width: 23,
                                    height: 23,
                                    borderRadius: "50%",
                                    marginRight: 1,
                                    objectFit: "cover",
                                  }}
                                />
                              )}
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                        fullWidth
                      />
                    )}
                  />
                </Mui.Grid>
              </Mui.Grid>

              <Mui.Grid
                container
                sx={{ justifyContent: "right", paddingBottom: 2 }}
              >
                <CustomButton
                  key={buttonLoader}
                  actionName="Update"
                  typeName="submit"
                  disableAction={buttonLoader}
                />
              </Mui.Grid>
            </Mui.Stack>
          </Mui.Grid>
          <Mui.Grid xs={12} sm={12} md={3} lg={3}></Mui.Grid>
        </Mui.Grid>
      </form>
    </React.Fragment>
  );
};

function Tag(props) {
  const { label, onDelete, ...other } = props;
  return (
    <div {...other}>
      <span>{label}</span>
      <Close onClick={onDelete} />
    </div>
  );
}

Tag.propTypes = {
  label: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};
